import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { IColumnModel, ColumnModel } from 'table-editor';
import { ITableColumn, TableColumn, ColumnDataTypes } from 'new-table-editor';
import { ImageFile } from './imageFile';

/** @deprecated Use LU_Keyword + KeywordLinking instead. */
export class Keyword extends StarbaseEntity implements Serializable<Keyword> {
    public fileModelUID: number;
    public fileUID: number;
    public keyword: string;

    constructor() {
        super();
    }

    public static keywordColumnData(): IColumnModel[] {
        return [
            new ColumnModel('UID', 'uid', 'uid', false, 'number', false, true, 10, false, null, null, 0, null, null, null, true),
            new ColumnModel('Image UID', 'fileModelUID', 'FileModelUID', false, 'number', false, true, 10, false, null, null, 0),
            new ColumnModel('Keyword', 'keyword', 'Keyword', true, 'typeahead', false, true, 100, false),
            new ColumnModel('Date/Time Added', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, true),
            new ColumnModel('Added By', 'createdByUser', 'CreatedByUser', false, 'string', false, true, 100, true)
        ];
    }

    deserialize(input) {
        return Object.assign(new Keyword(), input);
    }

}

/** Set list of keywords available to tag on an image record. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export class LU_Keyword extends StarbaseEntity implements Serializable<LU_Keyword> {
    public keyword: string;
    public active: boolean;
    public reviewed: boolean;
    public appears: number;
    public keywords: LU_Keyword[] = [];
    public relatedKeywords: LU_Keyword[] = [];
    public parents: LU_Keyword[] = [];
    public children: LU_Keyword[];

    public get synonyms(): LU_Keyword[] {
        return [... new Set([...this.keywords, ...this.relatedKeywords])];
    }


    public static KeywordColumns(showUID = false, showGUID = false, showWhodunits = false): ITableColumn[] {
        const keywordCol = new TableColumn('keyword', 'Keyword', ColumnDataTypes.string, true, true, true);
        keywordCol.sortAsc = true;
        keywordCol.maxLength = 100;
        return [
            ...TableColumn.generateColumnsForStarbaseEntity(showUID, showGUID, showWhodunits),
            keywordCol,
            new TableColumn('active', 'Active', ColumnDataTypes.yesno, true, true, false, true),
            new TableColumn('reviewed', 'Reviewed', ColumnDataTypes.yesno, false, true),
            new TableColumn('appears', 'Appears', ColumnDataTypes.number, false, false)
        ];
    }

    deserialize(input) {
        return Object.assign(new LU_Keyword(), input);
    }
}

export class KeywordLinking {
    public uid: number; // indexed view key
    public lU_KeywordUID: number;
    public lU_Keyword: LU_Keyword;
    public imageModelUID: number;
    public imageModel: ImageFile;
    public createdByUser: string;
    public createdDateTime: Date;
    public lastModifiedByUser: string;
    public lastModifiedDateTime: Date;
}
